import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/lib/query';
import { isServerUnreachableError } from '@/lib/utils';
import { getMe } from '../services/auth-service';

/** One more try for a gateway blip, so a single 502 heals without a screen (NPJB-815). */
const retryGatewayBlip = (failureCount: number, error: unknown): boolean =>
  failureCount < 1 &&
  isServerUnreachableError(error) &&
  typeof (error as { status?: unknown }).status === 'number';

export function useMeQuery(enabled = true) {
  return useQuery({
    queryKey: queryKeys.auth.me(),
    queryFn: getMe,
    enabled,
    // Never for an auth answer (401/403): that goes to /login at once. A timeout is not
    // retried either, or a hung gateway would hold the loader for twice as long.
    retry: retryGatewayBlip,
    retryDelay: 1000,
    staleTime: 5 * 60 * 1000, // 5 minutes — avoid refetching on every route change
  });
}
